module.exports = __webpack_public_path__ + "img/nftplay-shape-2.e912bf1d.png";